var map = {
	"./afghanistan-logo-icon.png": "8f56",
	"./australia-logo-icon.png": "e558",
	"./bangladesh-logo-icon.png": "8f29",
	"./canada-logo-icon.png": "5da0",
	"./durban's-super-giants-logo-icon.png": "df04",
	"./england-logo-icon.png": "7922",
	"./india-logo-icon.png": "7f2d",
	"./ireland-logo-icon.png": "afdb",
	"./joburg-super-kings-logo-icon.png": "7533",
	"./mi-cape-town-logo-icon.png": "7687",
	"./nambia-logo-icon.png": "d664",
	"./nepal-logo-icon.png": "ea81",
	"./netherlands-logo-icon.png": "f234",
	"./new-zealand-logo-icon.png": "5184",
	"./oman-logo-icon.png": "5bb8",
	"./paarl-royals-logo-icon.png": "406f",
	"./pakistan-logo-icon.png": "cfaa",
	"./papua-new-guinea-logo-icon.png": "2e3e",
	"./pretoria-capitals-logo-icon.png": "a551",
	"./scotland-logo-icon.png": "bb8a",
	"./south-africa-logo-icon.png": "bcde",
	"./sri-lanka-logo-icon.png": "f9fd",
	"./sunrisers-eastern-cape-logo-icon.png": "d12f",
	"./uganda-logo-icon.png": "287d",
	"./united-states-logo-icon.png": "55ca",
	"./west-indies-logo-icon.png": "1398",
	"./zimbabwe-logo-icon.png": "e82c"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "0b6f";